import React, { useEffect, useState, useContext } from 'react';
import { getEdi3000R24ViewList, getEdi3000R24ViewUser } from '../../lib/api/edi3000_r24_view';
import { useHistory } from 'react-router-dom';
// style
//import { Button } from '@material-ui/core';
import { Button,Backdrop,CircularProgress,makeStyles } from '@material-ui/core';
// component
import AdmEdiInfoListTable from './AdmEdiInfoListTable';
import SpaceRow from '../commons/SpaceRow';
// context
import { AuthContext } from '../../App';
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
function AdmEdiInfoList(props) {
    const { manifestNo } = props;
    const { loading, isSignedIn, setIsSignedIn, currentUser } = useContext(AuthContext);
    const [dataList, setDataList] = useState([]);

    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        handleGetList();
    }, []);

    const handleGetList = async () => {
        try {
            setOpen(!open);
            const res = manifestNo ? 
                await getEdi3000R24ViewUser(manifestNo) :
                await getEdi3000R24ViewList();
            setDataList(res.data);
            setOpen(false);
        } catch (e) {
            console.log(e);
            console.log(e.response);
        }
    };

    const history = useHistory();

    return (
        <div>
            <h1>　JWNET（EDI）通知情報</h1>
            {/* <Button
              variant='contained'
              color='primary'
              onClick={() => history.push('/egs_m_linkageSel')}
            >
              連携マスタより参照作成
            </Button> */}
            <Backdrop className={classes.backdrop} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <SpaceRow height={20} />
            <AdmEdiInfoListTable
                dataList={dataList}
            />
        </div>
    );
}
export default AdmEdiInfoList;
